module.exports = __webpack_public_path__ + "img/music.6f2a6279.svg";